import { render, staticRenderFns } from "./QuotationRatesReport.vue?vue&type=template&id=540248ca&scoped=true&"
import script from "./QuotationRatesReport.vue?vue&type=script&lang=js&"
export * from "./QuotationRatesReport.vue?vue&type=script&lang=js&"
import style0 from "./QuotationRatesReport.vue?vue&type=style&index=0&id=540248ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540248ca",
  null
  
)

export default component.exports